/**
 * Scenario Studio (`/scenarios`) event names.
 * Prefix `scenarios_` — not “studio”. Do not rename; Mixpanel funnels will depend on these.
 */
export const ScenariosEventTypes = {
  SESSION_CREATED: 'scenarios_session_created',
  SESSION_CLONED: 'scenarios_session_cloned',
  SESSION_OPENED: 'scenarios_session_opened',
  SESSION_DELETED: 'scenarios_session_deleted',
  SESSION_PUBLISHED: 'scenarios_session_published',
  SESSION_UNPUBLISHED: 'scenarios_session_unpublished',
  SESSION_WENT_LIVE: 'scenarios_session_went_live',
  SESSION_ENDED: 'scenarios_session_ended',
  SESSION_SHARED: 'scenarios_session_shared',
  TEMPLATE_OPENED: 'scenarios_template_opened',
  WIZARD_COMPLETED: 'scenarios_wizard_completed',
  AUDIENCE_CHANGED: 'scenarios_audience_changed',

  HUB_CONNECT_FAILED: 'scenarios_hub_connect_failed',
  SESSION_JOINED: 'scenarios_session_joined',
  SESSION_JOIN_DENIED: 'scenarios_session_join_denied',
  SESSION_LEFT: 'scenarios_session_left',
  WRITE_DENIED: 'scenarios_write_denied',

  CLOCK_STARTED: 'scenarios_clock_started',
  CLOCK_PAUSED: 'scenarios_clock_paused',
  CLOCK_RESUMED: 'scenarios_clock_resumed',
  CLOCK_STOPPED: 'scenarios_clock_stopped',
  RUN_STARTED: 'scenarios_run_started',
  RUN_STOPPED: 'scenarios_run_stopped',
  INSTANT_REPLAY_STARTED: 'scenarios_instant_replay_started',
  INSTANT_REPLAY_STOPPED: 'scenarios_instant_replay_stopped',
  RUN_REVIEWED: 'scenarios_run_reviewed',
  RUN_REVIEW_ENDED: 'scenarios_run_review_ended',
  VERSION_APPLIED: 'scenarios_version_applied',
  VERSION_DUPLICATED: 'scenarios_version_duplicated',
  VERSION_RENAMED: 'scenarios_version_renamed',

  INVITE_SENT: 'scenarios_invite_sent',
  INVITE_CHECK_FAILED: 'scenarios_invite_check_failed',
  INVITE_ACCEPTED: 'scenarios_invite_accepted',
  INVITE_DECLINED: 'scenarios_invite_declined',
  ROSTER_UPDATED: 'scenarios_roster_updated',
  PRESENTER_SET: 'scenarios_presenter_set',
  VIEWING_AS_STARTED: 'scenarios_viewing_as_started',
  VIEWING_AS_ENDED: 'scenarios_viewing_as_ended',

  OBJECT_ADDED: 'scenarios_object_added',
  OBJECT_REMOVED: 'scenarios_object_removed',
  COMMENT_SENT: 'scenarios_comment_sent',
  COMMENT_EDITED: 'scenarios_comment_edited',
  COMMENT_WITHDRAWN: 'scenarios_comment_withdrawn',

  MAP_TAPPED: 'scenarios_map_tapped',
  MAP_DETAILS_CLOSED: 'scenarios_map_details_closed',

  PANE_OPENED: 'scenarios_pane_opened',
  SETTING_CHANGED: 'scenarios_setting_changed',
  INSPECT_CHANGED: 'scenarios_inspect_changed',
  INSPECT_ACTION: 'scenarios_inspect_action',
  MODAL_DISMISSED: 'scenarios_modal_dismissed',
  SHORTCUT_USED: 'scenarios_shortcut_used',
} as const

export type ScenariosEventName =
  (typeof ScenariosEventTypes)[keyof typeof ScenariosEventTypes]
